import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const LiquorFields: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const {
    categoryType,
    alcoholContent,
    bottleSize,
    packagingType,
    shelfLife,
    warnings,
    headingColor,
    textColor,
    headingFontStyle,
    fontStyle
  } = context.product;

  return (
    <>
      {categoryType && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Category/Type
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {categoryType}
          </p>
        </div>
      )}
      {alcoholContent && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Alcohol Content
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {alcoholContent}
          </p>
        </div>
      )}
      {bottleSize && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Bottle Size
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {bottleSize}
          </p>
        </div>
      )}
      {packagingType && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Packaging Type
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {packagingType}
          </p>
        </div>
      )}
      {shelfLife && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Shelf Life
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {shelfLife}
          </p>
        </div>
      )}
      {warnings && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Warnings
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {warnings}
          </p>
        </div>
      )}
    </>
  );
};

export default LiquorFields;
